import { graphql } from 'gatsby';
import GlobalHead from '../../layout/head';

import { useAuthorSchema } from '../../../components/json-ld/author';
import layoutTheme from '../../editorial/theme';
import Layout from '../../layout';
import AuthorArchiveLayout from './layout';

import type { HeadProps, PageProps } from 'gatsby';
import type { IPageContext } from '../category/types';
import type { IAuthorArchiveData } from './types';

const AuthorArchiveTemplate = ({ data, pageContext, ...pageProps }: PageProps<IAuthorArchiveData, IPageContext>) => (
  <Layout
    {...pageProps}
    {...pageContext}
    showBreadcrumbs={false}
    templateName="Editorial"
    theme={layoutTheme}
  >
    <AuthorArchiveLayout data={data} pageContext={pageContext} />
  </Layout>
);

export const query = graphql`
  query AuthorArchiveTemplate($id: String!, $skip: Int!, $limit: Int!) {
    wpUser(id: {eq: $id}) {
      ...AuthorArchiveAuthorDetails
    }
    allWpPost(
      skip: $skip
      limit: $limit
      sort: {date: DESC}
      filter: {author: {node: {id: {eq: $id}}}}
    ) {
      nodes {
        ...BlogCardPost
      }
    }
  }
`;

export const Head = ({
  data,
  location,
  pageContext,
}: HeadProps<IAuthorArchiveData, IPageContext>) => (
  <GlobalHead
    pathname={location.pathname}
    seo={{
      title: `Posts by ${data?.wpUser?.firstName} ${data?.wpUser?.lastName} | Klaviyo`,
      canonical: pageContext?.headlessSeo?.canonical + (pageContext?.pageNumber > 0 ? `/${pageContext.pageNumber + 1}/` : ''),
      metaRobotsNofollow: 'follow',
      metaRobotsNoindex: 'index',
      prevPagePath: (pageContext?.previousPagePath ? pageContext?.previousPagePath : ''),
      nextPagePath: (pageContext?.nextPagePath ? pageContext?.nextPagePath : ''),
    }}
    isPaginated={(pageContext && pageContext?.numberOfPages > 0)}
  >
    <script type="application/ld+json">{useAuthorSchema(data)}</script>  
  </GlobalHead>
);

export default AuthorArchiveTemplate;
